import {
  notificationChannelView,
  type CreateNotificationChannelRequest,
  type DeliveryResult,
  type NotificationChannelView,
  type UpdateNotificationChannelRequest,
} from '@occ/contracts';
import { del, get, patch, post } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Canales de notificación (Módulo 12): Slack, WhatsApp, correo y Discord.
 *
 * El backend ya evita depender de `.env` para lo que rota —el webhook de
 * Slack, el token de WhatsApp, ahora el de Discord— desde que se escribió M12:
 * viven cifrados en `notification_channels.secret_encrypted`, editables por
 * esta misma API sin redeploy. Lo que faltaba era la pantalla que la usara
 * (M15 §3); este archivo es su capa de datos.
 */

const asArray = (payload: unknown): unknown[] => (Array.isArray(payload) ? payload : []);
const parseList = (payload: unknown): NotificationChannelView[] =>
  asArray(payload).map((row) => notificationChannelView.parse(row));

export const listNotificationChannels = async (): Promise<NotificationChannelView[]> =>
  parseList(await get(ROUTES.notificationChannels));

export const createNotificationChannel = async (
  request: CreateNotificationChannelRequest,
): Promise<NotificationChannelView> =>
  notificationChannelView.parse(await post(ROUTES.notificationChannels, request));

export const updateNotificationChannel = async (
  id: string,
  request: UpdateNotificationChannelRequest,
): Promise<NotificationChannelView> =>
  notificationChannelView.parse(await patch(ROUTES.notificationChannel(id), request));

export const deleteNotificationChannel = (id: string): Promise<void> =>
  del(ROUTES.notificationChannel(id));

/**
 * Envío de prueba. Es la única forma honesta de saber si un canal funciona: un
 * webhook mal pegado no falla al guardarlo, falla la noche del primer incidente.
 */
export const testNotificationChannel = (id: string): Promise<DeliveryResult> =>
  post(ROUTES.testNotificationChannel(id));
